export default __webpack_public_path__ + "static/media/zodiac08.bbc5125b.png";